import { useEffect } from 'react';

// A hooky way to update the browser title
export const useDocumentTitle = (title) => {
  useEffect(() => {
    document.title = title;
  }, [title]);
};
